import { setDefaultAnimation } from '@shoelace-style/shoelace/dist/utilities/animation-registry.js';
import '@shoelace-style/shoelace/dist/themes/light.css'
import { CustomElement } from '@/utils';

export default () => {
  const modules = import.meta.glob('./*.ts');

  for (const path in modules) {
    modules[path]().then((module: any) => {
      if (module && module.default) {
        if (!customElements.get(module.default.component)) {
          customElements.define(module.default.component, module.default);
        }
      }
    });
  }

  Promise.all([
    import('@shoelace-style/shoelace/dist/components/dropdown/dropdown.js'),
    import('@shoelace-style/shoelace/dist/components/select/select.js'),
    import('@shoelace-style/shoelace/dist/components/option/option.js'),
    import('@shoelace-style/shoelace/dist/components/menu/menu.js'),
  ]).then(() => {
    setDefaultAnimation('dropdown.show', null);
    setDefaultAnimation('dropdown.hide', {
      keyframes: [],
      options: {
        duration: 0
      }
    });
    setDefaultAnimation('select.show', null);
    setDefaultAnimation('select.hide', null);
  });
};
